import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offerItems } from '../data/salesContent';
type OfferSectionProps = {
  id?: string;
  eyebrow?: string;
  heading?: string;
};
export function OfferSection({
  id = 'offer',
  eyebrow = 'Get Your Blueprint',
  heading = 'The Core-Floor Blueprint™'
}: OfferSectionProps) {
  return <section id={id} className="w-full bg-ink-800 py-16 sm:py-20" aria-labelledby={`${id}-title`} style={{
    paddingBottom: "0px"
  }} data-id="element-118" data-mp="id8cysvgt2uv">
      <div className="mx-auto max-w-md px-5" data-id="element-119" data-mp="me1zbht9e9ln">
        <div className="rounded-3xl border border-gold/30 bg-ink-700 px-6 py-10 text-center sm:px-9" data-id="element-120" data-mp="mgwlbdrx82h6">
          <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-gold" data-id="element-121" data-mp="rbtpa6acfln7">
            {eyebrow}
          </p>
          <h2 id={`${id}-title`} className="mt-3 font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-122" data-mp="2t5j9t1uljrt5">
            {heading}
          </h2>

          <ul className="mx-auto mt-7 space-y-2.5 text-left" data-id="element-123" data-mp="2y55ozgtzji4l">
            {offerItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-124" data-mp="12ojysjq5ogpg">
                <CheckIcon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-125" data-mp="xx1ze03s6o6l" />
                <span className="text-[15px] leading-snug text-lilac-100" data-id="element-126" data-mp="swxii8yynrfu">{item}</span>
              </li>)}
          </ul>

          <div className="mt-8 border-t border-white/10 pt-7" data-id="element-127" data-mp="oxeswzw72s6o">
            <p className="text-sm font-medium text-muted" data-id="element-128" data-mp="1lmwb2ecd66p9">
              Total value: <span className="line-through" data-id="element-129" data-mp="1lk0b6kgyh7y6">$243</span>
            </p>
            <p className="mt-1 font-display text-6xl font-bold leading-none text-white" data-id="element-130" data-mp="1gnt6sw47k4ic">
              $27
              <span className="ml-2 align-middle text-base font-semibold text-muted" data-id="element-131" data-mp="1cjv6ii35cnnp">
                USD
              </span>
            </p>
          </div>

          <div className="mt-7 flex justify-center" data-id="element-132" data-mp="16sxc83dn0dk">
            <CtaButton data-id="element-133" data-mp="146gtiyidaj7" />
          </div>
          <p className="mt-5 text-[11px] font-medium leading-relaxed text-muted" data-id="element-134" data-mp="3sckmp59by8zb">
            🔒 Secure · ⚡ 5-min access · 🛡️ 7-day guarantee · 💳 All cards
          </p>
        </div>
      </div>
    </section>;
}